import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import styled from "styled-components";

const BlockUnblockVerifyOtp = ({ onBlockOrUnblock, accountInfoData }) => {
  const [loading, setloading] = useState(false);
  const [loadingIcon, setloadingIcon] = useState("pi pi-save");
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [otpLimitText, setOtpLimitText] = useState("");

  useEffect(() => {
    // Check localStorage on component mount to see if button should be disabled
    const clickData = JSON.parse(localStorage.getItem("buttonClickData")) || {};
    const { clicks, timestamp } = clickData;
    const now = new Date().getTime();

    if (clicks >= 4 && timestamp && now - timestamp < 120000) {
      setIsButtonDisabled(true);
      const remainingTime = 120000 - (now - timestamp);
      setTimeout(() => resetClicks(), remainingTime);
    } else {
      resetClicks();
    }
  }, []);

  const resetClicks = () => {
    setIsButtonDisabled(false);
    setOtpLimitText("");
    localStorage.removeItem("buttonClickData");
  };

  const handleButtonClick = () => {
    const clickData = JSON.parse(localStorage.getItem("buttonClickData")) || {
      clicks: 0,
      timestamp: 0,
    };
    let { clicks } = clickData;
    clicks += 1;

    if (clicks >= 4) {
      setIsButtonDisabled(true);
      localStorage.setItem(
        "buttonClickData",
        JSON.stringify({ clicks, timestamp: new Date().getTime() })
      );
      setOtpLimitText("Too many wrong attemps! Please try after 2mins.");
      setTimeout(() => resetClicks(), 120000); // 2-minute timer
    } else {
      localStorage.setItem(
        "buttonClickData",
        JSON.stringify({ clicks, timestamp: clickData.timestamp })
      );
    }
  };

  const otpRefs = useRef([]);
  const addRef = (el) => {
    if (el && !otpRefs.current.includes(el)) {
      otpRefs.current.push(el);
    }
  };

  const handleInputChange = (e, index) => {
    formik.setFieldValue(`otp${index + 1}`, e.target.value);

    if (e.target.value.length === 1 && index < 4) {
      otpRefs.current[index + 1].focus();
    } else if (e.target.value === "" && index > 0) {
      // keyCode 8 is for backspace
      otpRefs.current[index - 1].focus();
    }
  };

  const handleFocus = (e) => {
    // Set the cursor to the end
    const valueLength = e.target.value.length;
    e.target.setSelectionRange(valueLength, valueLength);
  };

  const handleKeyNavigation = (e, index) => {
    if (e.keyCode === 37 && index > 0) {
      // left arrow key
      otpRefs.current[index - 1].focus();
    } else if (e.keyCode === 39 && index < 4) {
      // right arrow key
      otpRefs.current[index + 1].focus();
    }
  };

  const formik = useFormik({
    initialValues: {
      otp1: "",
      otp2: "",
      otp3: "",
      otp4: "",
      otp5: "",
    },
    onSubmit: async (values) => {
      setloading(true);
      setloadingIcon("pi pi-spin pi-spinner");
      try {
        const otp =
          values.otp1 + values.otp2 + values.otp3 + values.otp4 + values.otp5;
        await onBlockOrUnblock(
          otp,
          accountInfoData.AccountStatus === "UN-BLOCK" ? "01" : "02"
        );
        formik.resetForm();
      } catch (err) {
        console.error("Error verifying OTP:", err);
      } finally {
        setloading(false);
        setloadingIcon("pi pi-save");
      }
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  useEffect(() => {
    if (
      !formik.values.otp1 ||
      !formik.values.otp2 ||
      !formik.values.otp3 ||
      !formik.values.otp4 ||
      !formik.values.otp5
    ) {
      setDisableSubmit(true);
    } else setDisableSubmit(false);
  }, [
    formik.values.otp1,
    formik.values.otp2,
    formik.values.otp3,
    formik.values.otp4,
    formik.values.otp5,
  ]);

  return (
    <div className="card Card__Round">
      <div className="Form__Header">
        <h1> Verify OTP </h1>
      </div>
      <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
        <div className="p-mt-4">
          <div>
            <p>
              Please enter the OTP code sent to your registered Mobile Number /
              Email Address.
              <br />
            </p>
            <div>
              {[1, 2, 3, 4, 5].map((_, index) => (
                <Input
                  key={index}
                  maxLength="1"
                  ref={addRef}
                  onChange={(e) => handleInputChange(e, index)}
                  onKeyDown={(e) => handleKeyNavigation(e, index)}
                  onFocus={handleFocus}
                  value={formik.values[`otp${index + 1}`]}
                  name={`otp${index + 1}`}
                  type="text"
                />
              ))}
              {getFormErrorMessage("otp")}
            </div>
            <small
              className="p-mt-4"
              style={{ display: "block", color: "red" }}
            >
              {otpLimitText && otpLimitText}
            </small>
            <div className="Down__Btn p-mt-4">
              {/* <Button
                                disabled={loading || disableSubmit}
                                icon={loadingIcon || ""}
                                iconPos="right"
                                label="Verify"
                                className="Btn__Transparent"
                                type="submit"
                            /> */}

              {accountInfoData.AccountStatus === "UN-BLOCK" ? (
                <Button
                  disabled={isButtonDisabled || loading || disableSubmit}
                  label={"Verfiy & Block"}
                  className="Btn__Dark"
                  icon={`${isButtonDisabled ? "pi pi-ban" : ""}`}
                  onClick={handleButtonClick}
                />
              ) : (
                <Button
                  disabled={isButtonDisabled || loading || disableSubmit}
                  label={"Verfiy & Unblock"}
                  className="Btn__Dark"
                  icon={`${isButtonDisabled ? "pi pi-ban" : ""}`}
                  onClick={handleButtonClick}
                />
              )}
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

const Input = styled.input`
  width: 40px;
  margin: 0 5px;
  text-align: center;
`;

export default BlockUnblockVerifyOtp;
